export const name: string = 'vehicles';

export const types = {
    GET_VEHICLE: name + '/GET_VEHICLE',
    EDIT_VEHICLE: name + '/EDIT_VEHICLE',
    SET_ENABLE: name + '/SET_ENABLE',
    GET_VEHICLE_TYPE: name + '/GET_VEHICLE_TYPE',
    SAVE_VEHICLE_TYPE: name + '/SAVE_VEHICLE_TYPE',
    GET_VEHICLE_TYPES: name + '/GET_VEHICLE_TYPES',
};
